/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Submit1Inputs */

const vi_driverremittance_submit1 = /** @type {(inputs: Driverremittance_Submit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nộp quỹ`)
};

/**

* @param {Driverremittance_Submit1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_submit1 = /** @type {((inputs?: Driverremittance_Submit1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Submit1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_submit1(inputs)
});
export { driverremittance_submit1 as "driverRemittance_submit" }